import axios from '../config/axios';
import API_ENDPOINTS from '../config/api';

/**
 * Generate official + brief titles from clinical intake via Gemini.
 * Persists to Administrative Info and latest clinical intake on the server.
 */
export const generateOfficialTitlesFromIntake = async (projectId) => {
  if (!projectId) {
    throw new Error('Select a project before generating titles.');
  }
  const response = await axios.post(API_ENDPOINTS.ai.generateOfficialTitle, { projectId });
  if (!response.data?.success) {
    throw new Error(response.data?.error || 'Title generation failed');
  }
  return {
    official_title: response.data.official_title || '',
    brief_title: response.data.brief_title || response.data.short_title || '',
    short_title: response.data.short_title || response.data.brief_title || '',
  };
};
